import * as react from "react"
import { Navigate } from "react-router-dom"
import Cuestionario from "../../components/Cuestionario/Cuestionario"

const CuestionarioPage = (props) => {
    const existDataSession =  sessionStorage.getItem("interContratante")? true : false
    return (
        existDataSession? <Cuestionario isMobile={props.isMobile} /> : <Navigate to="/inicio?view=haveCotizacion" />
    )
}

export default CuestionarioPage